import { render, staticRenderFns } from "./centerMember.vue?vue&type=template&id=40fde27e&"
import script from "./centerMember.vue?vue&type=script&lang=js&"
export * from "./centerMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports